import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios'
import { GetBaseUrl } from '@/utils/ConfigHelper'
import { Link } from 'react-router-dom'
import { Container, Div, Title, NickName, CountDiv, Count, Img, ProfileImg, NickNamePannel } from './TitleArea.style';
import i18n from '../../i18n';
import { GetUserProfileURL } from '../../Interface'
import './TitleArea.scss';

class TitleArea extends Component {
    state = {
        userProfile: undefined
    }

    componentDidMount() {
        const { id } = this.props
        this.getUserProfile(id)
    }

    getUserProfile = async _id => {
        const profile = await GetUserProfileURL(_id)
        this.setState({ userProfile: profile })
    }

    handleClickNickName = (shareId, userId) => e => {
        if (shareId === '') return
        if (window.location.pathname.startsWith('/user-gallery')) return

        this.props.history.push(`/user-gallery/${shareId}`)
    }

    render() {
        const {
            title, 
            heartCount, 
            lang, 
            isHeartClicked, 
            id, 
            shareId,
            nickname, 
            onClickHashTag,
            onHeartClick, 
            onReport, 
            onShare,
            commentCount, 
            isStaffPick, 
            isHotVideo,
            viewCount, 
            hashTags,
            isFollowing,
            onClickFollowBtn,
            onClickEditHashtag,
            isMine
        } = this.props

        let { userProfile } = this.state
        if(!userProfile) userProfile = 'baseImg'

        const isLogined = (localStorage.getItem("token")) ? true : false

        return (
            <Container>
                <Div column margin={"0 0 2px 0"} width={"100%"}>
                    <Div column justifyContent={"flex-start"} margin={"0 0 10px 0"} alignItems={"center"} width={"100%"}>
                        <div className="gallery-dialog-title-nickname-container">
                            <ProfileImg
                                src={userProfile === 'baseImg' ? "https://front.videomonster.com/images-u6yd72dy/common/v2-profile.svg" : userProfile}
                                alt="icon-profile"
                                onClick={this.handleClickNickName(shareId, id)}
                            />
                            
                            <div 
                                className="title-nickname"  
                                onClick={this.handleClickNickName(shareId, id)}
                            > 
                                {nickname}
                            </div>

                            {
                                !isMine
                                &&
                                <img
                                    src={isFollowing ? "https://front.videomonster.com/images-u6yd72dy/web/followingIcon.svg" : "https://front.videomonster.com/images-u6yd72dy/web/newgallery/userFollowBefore.svg"}
                                    alt="icon-follow"
                                    onClick={() => { onClickFollowBtn(shareId, isFollowing) }}
                                />
                            }
                        </div>

                        <div className="gallery-dialog-title-videoname-container">
                            <div>{title}</div>

                            {   // 스태프픽 선택된 비디오
                                isStaffPick && <img src="https://front.videomonster.com/images-u6yd72dy/web/staffpick_detail_icon.png" alt='staffPick' style={{ marginLeft: '10px', height: '18px' }} />
                            }
                        </div>

                        {/* 해시태그 */}
                        <div className="gallery-dialog-hashTag-container">
                            {
                                hashTags && hashTags.length > 0
                                    ?
                                    hashTags.map(tag => {
                                        return <span className="hashTag-name" onClick={() => { onClickHashTag(tag) }}>{tag} </span>
                                    })
                                    :
                                    // 해시태그가 없는데 내 비디오 상세 다이얼로그인 경우
                                    isMine && isLogined && <span className="no-hashTag-name">{i18n.t("web.gallery.detail.plz.input.hashtag")}</span>
                            }
                            {   // 편집 아이콘 (내 비디오일 때만 노출)
                                isMine && isLogined && <img
                                    className="edit-hashTag-btn"
                                    src={'https://front.videomonster.com/images-u6yd72dy/web/hashtagEditIcon.svg'}
                                    alt='icon-hashtag-edit'
                                    onClick={() => { onClickEditHashtag() }}
                                />
                            }
                        </div>
                    </Div>

                    <Div justifyContent={"flex-start"} alignItems={"center"}>
                        <Div width="80%" justifyContent={"flex-start"} alignItems={"center"}>
                            <CountDiv cursor={"true"}>
                                <img style={{ width: "18px" }} src="https://front.videomonster.com/images-u6yd72dy/web/viewsIcon.svg" alt="icon-views"></img>
                                <Count>{viewCount}</Count>
                            </CountDiv>
                            <CountDiv margin={" 0 0 0 8px"} cursor={"true"}>
                                <span onClick={onHeartClick} className={isHeartClicked ? "click-heart heart" : "heart"}></span>
                                <Count>{heartCount}</Count>
                            </CountDiv>
                            <CountDiv margin={" 0 0 0 8px"} cursor={"true"}>
                                <img style={{ width: "18px" }} src="https://front.videomonster.com/images-u6yd72dy/mobile/comment.png" alt="commentIcon"></img>
                                <Count>{commentCount}</Count>
                            </CountDiv>
                        </Div>
                        <Div width="20%" justifyContent={"flex-end"} alignItems={"center"}>
                                <Img src="https://front.videomonster.com/images-u6yd72dy/web/sharedLinkPage/shareIcon.png" onClick={onShare} alt="shareIcon" />
                                <Img margin={"0 0 0 8px"} src="https://front.videomonster.com/images-u6yd72dy/web/sharedLinkPage/reportIcon.png" onClick={onReport} alt="reportIcon" />
                        </Div>
                    </Div>
                </Div>
            </Container>
        );
    }
}

const mapStateToProps = state => ({
    lang: state.langStore.lang
})

export default connect(
    mapStateToProps,
    null
)(TitleArea)